import { render } from "./index.vue?vue&type=template&id=675ae9e6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/BaseForm/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "675ae9e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('675ae9e6', __exports__)) {
    api.reload('675ae9e6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=675ae9e6", () => {
    api.rerender('675ae9e6', render)
  })

}


export default __exports__